import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const FavCtx = createContext(null);
export const useFavorites = () => useContext(FavCtx);

export const FavoritesProvider = ({ children }) => {
  const { user, login } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setIds([]); return; }
    try { const res = await api.get("/favorites"); setIds(res.data.product_ids); } catch {}
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isFav = useCallback((id) => ids.includes(id), [ids]);

  const toggle = useCallback(async (id) => {
    if (!user) { toast("Inicia sesión para guardar favoritos"); login(); return; }
    const currently = ids.includes(id);
    setIds((prev) => currently ? prev.filter((x) => x !== id) : [...prev, id]);
    try {
      if (currently) await api.delete(`/favorites/${id}`);
      else await api.post(`/favorites/${id}`);
    } catch { refresh(); }
  }, [user, ids, login, refresh]);

  return <FavCtx.Provider value={{ ids, isFav, toggle, refresh, count: ids.length }}>{children}</FavCtx.Provider>;
};
